import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmManagementStore,
	TEmManagementListResponsePayload,
	TEmManagementListRequest,
	TEmManagementByIdResponsePayload,
	TEmManagementByIdRequest,
	TEmManagementByIdFullRequest,
	TEmManagementByIdFullResponsePayload,
	TEmManagementUpdateRequest,
	TEmManagementUpdateResponsePayload,
	TEmManagementEmerchantUpdateRequest,
	TEmManagementEmerchantUpdateResponsePayload,
	TAdditionalServicesRequest,
	TAdditionalServicesResponsePayload,
	TAdditionalServiceCreateRequest,
	TAdditionalServiceCreateResponsePayload,
	TAdditionalServiceUpdateRequest,
	TAdditionalServiceUpdateResponsePayload,
	TEmAdditionalServicesResponsePayload,
	TEmAdditionalServiceCreateRequest,
	TEmAdditionalServiceCreateResponsePayload,
	TEmAdditionalServiceUpdateRequest,
	TEmAdditionalServiceUpdateResponsePayload,
	TEmAdditionalServiceInvoiceRequest,
	TEmAdditionalServiceInvoiceResponsePayload,
	TEmAdditionalServiceCancelRequest,
	TEmAdditionalServiceCancelResponsePayload,
	TEmInvoicePdfRequest,
	TEmInvoicePdfResponsePayload,
	TSpecialRegistrationsRequest,
	TSpecialRegistrationsResponsePayload,
	TSpecialRegistrationCreateRequest,
	TSpecialRegistrationCreateResponsePayload,
	TSpecialRegistrationUpdateRequest,
	TSpecialRegistrationUpdateResponsePayload,
	TScheduleTerminationCreateRequest,
	TScheduleTerminationCreateResponsePayload,
	TScheduleTerminationDeleteRequest,
	TScheduleTerminationDeleteResponsePayload,
	TEmEnumsRequest,
	TEmEnumsSuccessPayload,
	TDistinctEnumNamesPayload,
	TEnumByNameRequest,
	TEnumByNameSuccessPayload,
	TEnumByNameFailurePayload,
	TMonthlyFeesResponsePayload,
	TFeeClassesResponsePayload,
	// em comments
	TEmCommentsRequest,
	TEmCommentsResponsePayload,
	TEmCommentGetByIdRequest,
	TEmCommentGetByIdResponsePayload,
	TEmCommentCreateRequest,
	TEmCommentCreateResponsePayload,
	TEmCommentUpdateRequest,
	TEmCommentUpdateResponsePayload,
	// nominated person account
	TRegisterNominatedPersonAccountRequest,
	TRegisterNominatedPersonAccountResponsePayload,
	// em sites
	TEmSitesListRequest,
	TEmSitesListResponsePayload,
	TEmSiteCreateRequest,
	TEmSiteCreateResponsePayload,
	TEmSiteUpdateRequest,
	TEmSiteUpdateResponsePayload,
	TEmSiteDeleteRequest,
	TEmSiteDeleteResponsePayload,
	// dashboard users subscriptions
	TEmDashboardUsersSubscriptionsGetRequest,
	TEmDashboardUsersSubscriptionsGetResponsePayload,
	TEmDashboardUsersSubscriptionsUpdateRequest,
	TEmDashboardUsersSubscriptionsUpdateResponsePayload,
	TEmManagementUnblockRequest,
	TEmManagementUnblockResponsePayload,
	TEmManagementBlockRequest,
	TEmManagementBlockResponsePayload,
	TEmManagementActivateRequest,
	TEmManagementActivateResponsePayload,
	TEmManagementDuplicateRequest,
	TEmManagementDuplicateResponsePayload,
	TEuDdpActivateRequest,
	TEuDdpActivateResponsePayload,
	// em invoice list
	TEmInvoiceListRequest,
	TEmInvoiceListResponsePayload,
	// em payment methods
	TEmPaymentMethodsRequest,
	TEmPaymentMethodsResponsePayload,
} from './types';
import { EEmEnums } from './constants';
// ==========================================:
export const initialState: TEmManagementStore = {
	emManagementList: null,
	emManagementListLoading: false,
	emById: null,
	emByIdFull: null,
	emByIdLoading: false,
	emByIdFullLoading: false,
	emByIdFullError: null,
	updateEmLoading: false,
	updateEmSuccess: false,
	updateEmerchantLoading: false,
	updateEmerchantSuccess: null,
	unblockEmerchantLoading: false,
	unblockEmerchantSuccess: false,
	blockEmerchantLoading: false,
	blockEmerchantSuccess: false,
	activateEmerchantLoading: false,
	activateEmerchantSuccess: false,
	duplicateEmerchantLoading: false,
	duplicateEmerchantSuccess: false,
	activateEuDdpLoading: false,
	activateEuDdpSuccess: false,
	additionalServices: null,
	additionalServicesLoading: false,
	createAdditionalServiceLoading: false,
	createAdditionalServiceSuccess: false,
	updateAdditionalServiceLoading: false,
	updateAdditionalServiceSuccess: false,
	emAdditionalServices: null,
	emAdditionalServicesLoading: false,
	createEmAdditionalServiceLoading: false,
	createEmAdditionalServiceSuccess: false,
	updateEmAdditionalServiceLoading: false,
	updateEmAdditionalServiceSuccess: false,
	emAdditionalServiceInvoiceLoading: false,
	emAdditionalServiceInvoiceSuccess: false,
	// cancel em additional service
	emAdditionalServiceCancelLoading: false,
	emAdditionalServiceCancelSuccess: false,
	emInvoicePdfLoading: false,
	emInvoicePdfSuccess: false,
	// special registrations
	specialRegistrations: null,
	specialRegistrationsLoading: false,
	addSpecialRegistrationLoading: false,
	addSpecialRegistrationSuccess: false,
	updateSpecialRegistrationLoading: false,
	updateSpecialRegistrationSuccess: false,
	deleteScheduleTerminationLoading: false,
	deleteScheduleTerminationSuccess: false,
	// enums by type
	enumsFeeClass: null,
	enumsFeeClassLoading: false,
	enumsAnnualFeeTypeId: null,
	enumsAnnualFeeTypeIdLoading: false,
	enumsInvoiceFeeTypeId: null,
	enumsInvoiceFeeTypeIdLoading: false,
	// timezone list
	enumsTimezoneList: null,
	enumsTimezoneListLoading: false,
	// additional enums
	enumsWeightUnit: null,
	enumsWeightUnitLoading: false,
	enumsCustomsDataStatus: null,
	enumsCustomsDataStatusLoading: false,
	enumsPaymentMode: null,
	enumsPaymentModeLoading: false,
	enumsIossSaleOverThresholdOption: null,
	enumsIossSaleOverThresholdOptionLoading: false,
	enumsIossDutyMode: null,
	enumsIossDutyModeLoading: false,
	enumsSupportedCurrency: null,
	enumsSupportedCurrencyLoading: false,
	enumsCurrencyCode: null,
	enumsCurrencyCodeLoading: false,
	enumsReportingFeeActual: null,
	enumsReportingFeeActualLoading: false,
	enumsSiteIntegrationType: null,
	enumsSiteIntegrationTypeLoading: false,
	enumsSitePlatform: null,
	enumsSitePlatformLoading: false,
	enumsLegalStatusEu: null,
	enumsLegalStatusEuLoading: false,
	enumsManualFeeClass: null,
	enumsManualFeeClassLoading: false,
	enumsMonthlyFees: null,
	enumsMonthlyFeesLoading: false,
	enumsServiceType: null,
	enumsServiceTypeLoading: false,
	// enum dictionary browser (Reference Tables / Enums)
	distinctEnumNames: null,
	distinctEnumNamesLoading: false,
	enumsByName: {},
	enumsByNameLoading: {},
	enumsByNameError: {},
	// monthly fees and fee classes
	monthlyFees: null,
	monthlyFeesLoading: false,
	feeClasses: null,
	feeClassesLoading: false,
	// em comments
	emComments: null,
	emCommentsLoading: false,
	// em notifications
	emNotifications: null,
	emNotificationsLoading: false,
	emComment: null,
	emCommentLoading: false,
	createEmCommentLoading: false,
	createEmCommentSuccess: false,
	updateEmCommentLoading: false,
	updateEmCommentSuccess: false,
	// nominated person account
	registerNominatedPersonAccountLoading: false,
	registerNominatedPersonAccountSuccess: false,
	// em sites
	emSitesList: null,
	emSitesListLoading: false,
	createEmSiteLoading: false,
	createEmSiteSuccess: false,
	updateEmSiteLoading: false,
	updateEmSiteSuccess: false,
	deleteEmSiteLoading: false,
	deleteEmSiteSuccess: false,
	// dashboard users subscriptions
	emDashboardUsersSubscriptions: null,
	emDashboardUsersSubscriptionsLoading: false,
	updateEmDashboardUsersSubscriptionsLoading: false,
	updateEmDashboardUsersSubscriptionsSuccess: false,
	// em invoice list
	emInvoiceList: null,
	emInvoiceListLoading: false,
	// em payment methods
	emPaymentMethods: null,
	emPaymentMethodsLoading: false,
};

// ==========================================:
const emManagement = createSlice({
	name: '@@emManagement',
	initialState,
	reducers: {
		getEmEnumsRequest: (state: TEmManagementStore, action: PayloadAction<TEmEnumsRequest>) => {
			const emManagementState = state;
			if (action.payload.enumName === EEmEnums.FEES_CLASS) {
				emManagementState.enumsFeeClassLoading = true;
			}
			if (action.payload.enumName === EEmEnums.ANNUAL_FEE_TYPE_ID) {
				emManagementState.enumsAnnualFeeTypeIdLoading = true;
			}
			if (action.payload.enumName === EEmEnums.INVOICE_FEE_TYPE_ID) {
				emManagementState.enumsInvoiceFeeTypeIdLoading = true;
			}
			if (action.payload.enumName === EEmEnums.TIMEZONE_LIST) {
				emManagementState.enumsTimezoneListLoading = true;
			}
			if (action.payload.enumName === EEmEnums.WEIGHT_UNIT) {
				emManagementState.enumsWeightUnitLoading = true;
			}
			if (action.payload.enumName === EEmEnums.CUSTOMS_DATA_STATUS) {
				emManagementState.enumsCustomsDataStatusLoading = true;
			}
			if (action.payload.enumName === EEmEnums.PAYMENT_MODE) {
				emManagementState.enumsPaymentModeLoading = true;
			}
			if (action.payload.enumName === EEmEnums.IOSS_SALE_OVER_THRESHOLD_OPTION) {
				emManagementState.enumsIossSaleOverThresholdOptionLoading = true;
			}
			if (action.payload.enumName === EEmEnums.IOSS_DUTY_MODES) {
				emManagementState.enumsIossDutyModeLoading = true;
			}
			if (action.payload.enumName === EEmEnums.SUPPORTED_CURRENCY) {
				emManagementState.enumsSupportedCurrencyLoading = true;
			}
			if (action.payload.enumName === EEmEnums.CURRENCY_CODE) {
				emManagementState.enumsCurrencyCodeLoading = true;
			}
			if (action.payload.enumName === EEmEnums.EM_REPORTING_FEE_ACTUAL) {
				emManagementState.enumsReportingFeeActualLoading = true;
			}
			if (action.payload.enumName === EEmEnums.SITE_INTEGRATION_TYPE) {
				emManagementState.enumsSiteIntegrationTypeLoading = true;
			}
			if (action.payload.enumName === EEmEnums.SITE_PLATFORM) {
				emManagementState.enumsSitePlatformLoading = true;
			}
			if (action.payload.enumName === EEmEnums.LEGAL_STATUS_EU) {
				emManagementState.enumsLegalStatusEuLoading = true;
			}
			if (action.payload.enumName === EEmEnums.MANUAL_FEE_CLASS) {
				emManagementState.enumsManualFeeClassLoading = true;
			}
			if (action.payload.enumName === EEmEnums.MONTHLY_FEES) {
				emManagementState.enumsMonthlyFeesLoading = true;
			}
			if (action.payload.enumName === EEmEnums.SERVICE_TYPE) {
				emManagementState.enumsServiceTypeLoading = true;
			}
		},
		getEmEnumsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmEnumsSuccessPayload>,
		) => {
			const { enumName, data } = action.payload;
			const emManagementState = state;
			if (enumName === EEmEnums.FEES_CLASS) {
				emManagementState.enumsFeeClass = data;
				emManagementState.enumsFeeClassLoading = false;
			}
			if (enumName === EEmEnums.ANNUAL_FEE_TYPE_ID) {
				emManagementState.enumsAnnualFeeTypeId = data;
				emManagementState.enumsAnnualFeeTypeIdLoading = false;
			}
			if (enumName === EEmEnums.INVOICE_FEE_TYPE_ID) {
				emManagementState.enumsInvoiceFeeTypeId = data;
				emManagementState.enumsInvoiceFeeTypeIdLoading = false;
			}
			if (enumName === EEmEnums.TIMEZONE_LIST) {
				emManagementState.enumsTimezoneList = data;
				emManagementState.enumsTimezoneListLoading = false;
			}
			if (enumName === EEmEnums.WEIGHT_UNIT) {
				emManagementState.enumsWeightUnit = data;
				emManagementState.enumsWeightUnitLoading = false;
			}
			if (enumName === EEmEnums.CUSTOMS_DATA_STATUS) {
				emManagementState.enumsCustomsDataStatus = data;
				emManagementState.enumsCustomsDataStatusLoading = false;
			}
			if (enumName === EEmEnums.PAYMENT_MODE) {
				emManagementState.enumsPaymentMode = data;
				emManagementState.enumsPaymentModeLoading = false;
			}
			if (enumName === EEmEnums.IOSS_SALE_OVER_THRESHOLD_OPTION) {
				emManagementState.enumsIossSaleOverThresholdOption = data;
				emManagementState.enumsIossSaleOverThresholdOptionLoading = false;
			}
			if (enumName === EEmEnums.IOSS_DUTY_MODES) {
				emManagementState.enumsIossDutyMode = data;
				emManagementState.enumsIossDutyModeLoading = false;
			}
			if (enumName === EEmEnums.SUPPORTED_CURRENCY) {
				emManagementState.enumsSupportedCurrency = data;
				emManagementState.enumsSupportedCurrencyLoading = false;
			}
			if (enumName === EEmEnums.CURRENCY_CODE) {
				emManagementState.enumsCurrencyCode = data;
				emManagementState.enumsCurrencyCodeLoading = false;
			}
			if (enumName === EEmEnums.EM_REPORTING_FEE_ACTUAL) {
				emManagementState.enumsReportingFeeActual = data;
				emManagementState.enumsReportingFeeActualLoading = false;
			}
			if (enumName === EEmEnums.SITE_INTEGRATION_TYPE) {
				emManagementState.enumsSiteIntegrationType = data;
				emManagementState.enumsSiteIntegrationTypeLoading = false;
			}
			if (enumName === EEmEnums.SITE_PLATFORM) {
				emManagementState.enumsSitePlatform = data;
				emManagementState.enumsSitePlatformLoading = false;
			}
			if (enumName === EEmEnums.LEGAL_STATUS_EU) {
				emManagementState.enumsLegalStatusEu = data;
				emManagementState.enumsLegalStatusEuLoading = false;
			}
			if (enumName === EEmEnums.MANUAL_FEE_CLASS) {
				emManagementState.enumsManualFeeClass = data;
				emManagementState.enumsManualFeeClassLoading = false;
			}
			if (enumName === EEmEnums.MONTHLY_FEES) {
				emManagementState.enumsMonthlyFees = data;
				emManagementState.enumsMonthlyFeesLoading = false;
			}
			if (enumName === EEmEnums.SERVICE_TYPE) {
				emManagementState.enumsServiceType = data;
				emManagementState.enumsServiceTypeLoading = false;
			}
		},

		getDistinctEnumNamesRequest: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.distinctEnumNamesLoading = true;
		},
		getDistinctEnumNamesSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TDistinctEnumNamesPayload>,
		) => {
			const emManagementState = state;
			emManagementState.distinctEnumNames = action.payload;
			emManagementState.distinctEnumNamesLoading = false;
		},
		getDistinctEnumNamesFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.distinctEnumNamesLoading = false;
		},

		getEnumByNameRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEnumByNameRequest>,
		) => {
			const { enumName } = action.payload;
			const emManagementState = state;
			emManagementState.enumsByNameLoading[enumName] = true;
			delete emManagementState.enumsByNameError[enumName];
		},
		getEnumByNameSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEnumByNameSuccessPayload>,
		) => {
			const { enumName, data } = action.payload;
			const emManagementState = state;
			emManagementState.enumsByName[enumName] = data;
			emManagementState.enumsByNameLoading[enumName] = false;
			delete emManagementState.enumsByNameError[enumName];
		},
		/** The error is kept per enum name so the view can stop retrying and show what went wrong. */
		getEnumByNameFailure: (
			state: TEmManagementStore,
			action: PayloadAction<TEnumByNameFailurePayload>,
		) => {
			const { enumName, message } = action.payload;
			const emManagementState = state;
			emManagementState.enumsByNameLoading[enumName] = false;
			emManagementState.enumsByNameError[enumName] = message;
		},

		getMonthlyFeesRequest: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.monthlyFeesLoading = true;
		},
		getMonthlyFeesSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TMonthlyFeesResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.monthlyFees = payload;
			emManagementState.monthlyFeesLoading = false;
		},

		getFeeClassesRequest: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.feeClassesLoading = true;
		},
		getFeeClassesSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TFeeClassesResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.feeClasses = payload;
			emManagementState.feeClassesLoading = false;
		},

		// em comments
		getEmCommentsRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentsRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emCommentsLoading = true;
		},
		getEmCommentsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentsResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emComments = payload;
			emManagementState.emCommentsLoading = false;
		},
		// em notifications
		getEmNotificationsRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentsRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emNotificationsLoading = true;
		},
		getEmNotificationsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentsResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emNotifications = payload;
			emManagementState.emNotificationsLoading = false;
		},
		getEmCommentByIdRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentGetByIdRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emCommentLoading = true;
		},
		getEmCommentByIdSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentGetByIdResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emComment = payload;
			emManagementState.emCommentLoading = false;
		},
		createEmCommentRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.createEmCommentLoading = true;
			emManagementState.createEmCommentSuccess = false;
		},
		createEmCommentSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.createEmCommentLoading = false;
			emManagementState.createEmCommentSuccess = true;
		},
		createEmCommentFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.createEmCommentLoading = false;
			emManagementState.createEmCommentSuccess = false;
		},
		updateEmCommentRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmCommentLoading = true;
			emManagementState.updateEmCommentSuccess = false;
		},
		updateEmCommentSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmCommentUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmCommentLoading = false;
			emManagementState.updateEmCommentSuccess = true;
		},
		updateEmCommentFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateEmCommentLoading = false;
			emManagementState.updateEmCommentSuccess = false;
		},

		registerNominatedPersonAccountRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TRegisterNominatedPersonAccountRequest>,
		) => {
			const emManagementState = state;
			emManagementState.registerNominatedPersonAccountLoading = true;
			emManagementState.registerNominatedPersonAccountSuccess = false;
		},
		registerNominatedPersonAccountSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TRegisterNominatedPersonAccountResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.registerNominatedPersonAccountLoading = false;
			emManagementState.registerNominatedPersonAccountSuccess = true;
		},
		registerNominatedPersonAccountFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.registerNominatedPersonAccountLoading = false;
			emManagementState.registerNominatedPersonAccountSuccess = false;
		},

		// em sites
		getEmSitesListRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSitesListRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emSitesListLoading = true;
		},
		getEmSitesListSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSitesListResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emSitesList = payload;
			emManagementState.emSitesListLoading = false;
		},
		createEmSiteRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.createEmSiteLoading = true;
			emManagementState.createEmSiteSuccess = false;
		},
		createEmSiteSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.createEmSiteLoading = false;
			emManagementState.createEmSiteSuccess = true;
		},
		updateEmSiteRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmSiteLoading = true;
			emManagementState.updateEmSiteSuccess = false;
		},
		updateEmSiteSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmSiteLoading = false;
			emManagementState.updateEmSiteSuccess = true;
		},
		deleteEmSiteRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteDeleteRequest>,
		) => {
			const emManagementState = state;
			emManagementState.deleteEmSiteLoading = true;
			emManagementState.deleteEmSiteSuccess = false;
		},
		deleteEmSiteSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmSiteDeleteResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.deleteEmSiteLoading = false;
			emManagementState.deleteEmSiteSuccess = true;
		},

		// dashboard users subscriptions
		getEmDashboardUsersSubscriptionsRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmDashboardUsersSubscriptionsGetRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emDashboardUsersSubscriptionsLoading = true;
		},
		getEmDashboardUsersSubscriptionsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmDashboardUsersSubscriptionsGetResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emDashboardUsersSubscriptions = payload;
			emManagementState.emDashboardUsersSubscriptionsLoading = false;
		},
		updateEmDashboardUsersSubscriptionsRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmDashboardUsersSubscriptionsUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmDashboardUsersSubscriptionsLoading = true;
			emManagementState.updateEmDashboardUsersSubscriptionsSuccess = false;
		},
		updateEmDashboardUsersSubscriptionsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmDashboardUsersSubscriptionsUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmDashboardUsersSubscriptionsLoading = false;
			emManagementState.updateEmDashboardUsersSubscriptionsSuccess = true;
		},
		updateEmDashboardUsersSubscriptionsFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateEmDashboardUsersSubscriptionsLoading = false;
			emManagementState.updateEmDashboardUsersSubscriptionsSuccess = false;
		},

		// em invoice list
		getEmInvoiceListRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmInvoiceListRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emInvoiceListLoading = true;
		},
		getEmInvoiceListSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmInvoiceListResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emInvoiceList = payload;
			emManagementState.emInvoiceListLoading = false;
		},

		// em payment methods
		getEmPaymentMethodsRequest: (
			state: TEmManagementStore,
			_action: PayloadAction<TEmPaymentMethodsRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emPaymentMethodsLoading = true;
		},
		getEmPaymentMethodsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmPaymentMethodsResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emPaymentMethods = payload;
			emManagementState.emPaymentMethodsLoading = false;
		},

		getEmManagementListRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementListRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emManagementListLoading = true;
		},
		getEmManagementListSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementListResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emManagementList = payload;
			emManagementState.emManagementListLoading = false;
		},

		getEmByIdRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementByIdRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emByIdLoading = true;
		},
		getEmByIdSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementByIdResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emById = payload;
			emManagementState.emByIdLoading = false;
		},

		getEmByIdFullRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementByIdFullRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emByIdFullLoading = true;
			emManagementState.emByIdFullError = null;
		},
		getEmByIdFullSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementByIdFullResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emByIdFull = payload;
			emManagementState.emByIdFullLoading = false;
			emManagementState.emByIdFullError = null;
		},
		getEmByIdFullFailure: (state: TEmManagementStore, action: PayloadAction<string>) => {
			const emManagementState = state;
			emManagementState.emByIdFullLoading = false;
			emManagementState.emByIdFullError = action.payload;
		},

		updateEmRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmLoading = true;
			emManagementState.updateEmSuccess = false;
		},
		updateEmSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmLoading = false;
			emManagementState.updateEmSuccess = true;
		},
		updateEmFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateEmLoading = false;
			emManagementState.updateEmSuccess = false;
		},

		updateEmerchantRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementEmerchantUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmerchantLoading = true;
			emManagementState.updateEmerchantSuccess = null;
		},
		updateEmerchantSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementEmerchantUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			const { payload } = action;
			emManagementState.updateEmerchantLoading = false;
			emManagementState.updateEmerchantSuccess = payload?.message ?? null;
		},
		updateEmerchantFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateEmerchantLoading = false;
			emManagementState.updateEmerchantSuccess = null;
		},

		unblockEmerchantRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementUnblockRequest>,
		) => {
			const emManagementState = state;
			emManagementState.unblockEmerchantLoading = true;
			emManagementState.unblockEmerchantSuccess = false;
		},
		unblockEmerchantSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementUnblockResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.unblockEmerchantLoading = false;
			emManagementState.unblockEmerchantSuccess = true;
		},
		unblockEmerchantFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.unblockEmerchantLoading = false;
			emManagementState.unblockEmerchantSuccess = false;
		},

		blockEmerchantRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementBlockRequest>,
		) => {
			const emManagementState = state;
			emManagementState.blockEmerchantLoading = true;
			emManagementState.blockEmerchantSuccess = false;
		},
		blockEmerchantSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementBlockResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.blockEmerchantLoading = false;
			emManagementState.blockEmerchantSuccess = true;
		},
		blockEmerchantFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.blockEmerchantLoading = false;
			emManagementState.blockEmerchantSuccess = false;
		},
		resetBlockEmerchant: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.blockEmerchantLoading = false;
			emManagementState.blockEmerchantSuccess = false;
		},

		activateEmerchantRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementActivateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.activateEmerchantLoading = true;
			emManagementState.activateEmerchantSuccess = false;
		},
		activateEmerchantSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementActivateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.activateEmerchantLoading = false;
			emManagementState.activateEmerchantSuccess = true;
		},
		activateEmerchantFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.activateEmerchantLoading = false;
			emManagementState.activateEmerchantSuccess = false;
		},

		duplicateEmerchantRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementDuplicateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.duplicateEmerchantLoading = true;
			emManagementState.duplicateEmerchantSuccess = false;
		},
		duplicateEmerchantSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmManagementDuplicateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.duplicateEmerchantLoading = false;
			emManagementState.duplicateEmerchantSuccess = true;
		},
		duplicateEmerchantFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.duplicateEmerchantLoading = false;
			emManagementState.duplicateEmerchantSuccess = false;
		},

		activateEuDdpRequest: (
			state: TEmManagementStore,
			_action: PayloadAction<TEuDdpActivateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.activateEuDdpLoading = true;
			emManagementState.activateEuDdpSuccess = false;
		},
		activateEuDdpSuccess: (
			state: TEmManagementStore,
			_action: PayloadAction<TEuDdpActivateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.activateEuDdpLoading = false;
			emManagementState.activateEuDdpSuccess = true;
		},
		activateEuDdpFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.activateEuDdpLoading = false;
			emManagementState.activateEuDdpSuccess = false;
		},
		resetActivateEuDdp: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.activateEuDdpLoading = false;
			emManagementState.activateEuDdpSuccess = false;
		},

		getAdditionalServicesRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServicesRequest>,
		) => {
			const emManagementState = state;
			emManagementState.additionalServicesLoading = true;
		},
		getAdditionalServicesSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServicesResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.additionalServices = payload;
			emManagementState.additionalServicesLoading = false;
		},

		createAdditionalServiceRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServiceCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.createAdditionalServiceLoading = true;
			emManagementState.createAdditionalServiceSuccess = false;
		},
		createAdditionalServiceSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServiceCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.createAdditionalServiceLoading = false;
			emManagementState.createAdditionalServiceSuccess = true;
		},
		createAdditionalServiceFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.createAdditionalServiceLoading = false;
			emManagementState.createAdditionalServiceSuccess = false;
		},

		updateAdditionalServiceRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServiceUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateAdditionalServiceLoading = true;
			emManagementState.updateAdditionalServiceSuccess = false;
		},
		updateAdditionalServiceSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TAdditionalServiceUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateAdditionalServiceLoading = false;
			emManagementState.updateAdditionalServiceSuccess = true;
		},
		updateAdditionalServiceFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateAdditionalServiceLoading = false;
			emManagementState.updateAdditionalServiceSuccess = false;
		},

		getEmAdditionalServicesRequest: (state: TEmManagementStore, action: PayloadAction<number>) => {
			const emManagementState = state;
			emManagementState.emAdditionalServicesLoading = true;
		},
		getEmAdditionalServicesSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServicesResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.emAdditionalServices = payload;
			emManagementState.emAdditionalServicesLoading = false;
		},

		createEmAdditionalServiceRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.createEmAdditionalServiceLoading = true;
			emManagementState.createEmAdditionalServiceSuccess = false;
		},
		createEmAdditionalServiceSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.createEmAdditionalServiceLoading = false;
			emManagementState.createEmAdditionalServiceSuccess = true;
		},
		createEmAdditionalServiceFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.createEmAdditionalServiceLoading = false;
			emManagementState.createEmAdditionalServiceSuccess = false;
		},

		updateEmAdditionalServiceRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmAdditionalServiceLoading = true;
			emManagementState.updateEmAdditionalServiceSuccess = false;
		},
		updateEmAdditionalServiceSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateEmAdditionalServiceLoading = false;
			emManagementState.updateEmAdditionalServiceSuccess = true;
		},
		updateEmAdditionalServiceFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateEmAdditionalServiceLoading = false;
			emManagementState.updateEmAdditionalServiceSuccess = false;
		},

		emAdditionalServiceInvoiceRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceInvoiceRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceInvoiceLoading = true;
			emManagementState.emAdditionalServiceInvoiceSuccess = false;
		},
		emAdditionalServiceInvoiceSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceInvoiceResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceInvoiceLoading = false;
			emManagementState.emAdditionalServiceInvoiceSuccess = true;
		},
		emAdditionalServiceInvoiceFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceInvoiceLoading = false;
			emManagementState.emAdditionalServiceInvoiceSuccess = false;
		},

		emInvoicePdfRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmInvoicePdfRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emInvoicePdfLoading = true;
			emManagementState.emInvoicePdfSuccess = false;
		},
		emInvoicePdfSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmInvoicePdfResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.emInvoicePdfLoading = false;
			emManagementState.emInvoicePdfSuccess = true;
		},
		emInvoicePdfFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.emInvoicePdfLoading = false;
			emManagementState.emInvoicePdfSuccess = false;
		},

		// cancel em additional service
		emAdditionalServiceCancelRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceCancelRequest>,
		) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceCancelLoading = true;
			emManagementState.emAdditionalServiceCancelSuccess = false;
		},
		emAdditionalServiceCancelSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TEmAdditionalServiceCancelResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceCancelLoading = false;
			emManagementState.emAdditionalServiceCancelSuccess = true;
		},
		emAdditionalServiceCancelFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.emAdditionalServiceCancelLoading = false;
			emManagementState.emAdditionalServiceCancelSuccess = false;
		},

		getSpecialRegistrationsRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationsRequest>,
		) => {
			const emManagementState = state;
			emManagementState.specialRegistrationsLoading = true;
		},
		getSpecialRegistrationsSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationsResponsePayload>,
		) => {
			const { payload } = action;
			const emManagementState = state;
			emManagementState.specialRegistrations = payload;
			emManagementState.specialRegistrationsLoading = false;
		},

		addSpecialRegistrationRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.addSpecialRegistrationLoading = true;
			emManagementState.addSpecialRegistrationSuccess = false;
		},
		addSpecialRegistrationSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.addSpecialRegistrationLoading = false;
			emManagementState.addSpecialRegistrationSuccess = true;
		},
		addSpecialRegistrationFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.addSpecialRegistrationLoading = false;
			emManagementState.addSpecialRegistrationSuccess = false;
		},

		updateSpecialRegistrationRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationUpdateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = true;
			emManagementState.updateSpecialRegistrationSuccess = false;
		},
		updateSpecialRegistrationSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TSpecialRegistrationUpdateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = false;
			emManagementState.updateSpecialRegistrationSuccess = true;
		},
		updateSpecialRegistrationFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = false;
			emManagementState.updateSpecialRegistrationSuccess = false;
		},

		addScheduleTerminationRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TScheduleTerminationCreateRequest>,
		) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = true;
			emManagementState.updateSpecialRegistrationSuccess = false;
		},
		addScheduleTerminationSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TScheduleTerminationCreateResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = false;
			emManagementState.updateSpecialRegistrationSuccess = true;
		},
		addScheduleTerminationFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.updateSpecialRegistrationLoading = false;
			emManagementState.updateSpecialRegistrationSuccess = false;
		},

		deleteScheduleTerminationRequest: (
			state: TEmManagementStore,
			action: PayloadAction<TScheduleTerminationDeleteRequest>,
		) => {
			const emManagementState = state;
			emManagementState.deleteScheduleTerminationLoading = true;
			emManagementState.deleteScheduleTerminationSuccess = false;
		},
		deleteScheduleTerminationSuccess: (
			state: TEmManagementStore,
			action: PayloadAction<TScheduleTerminationDeleteResponsePayload>,
		) => {
			const emManagementState = state;
			emManagementState.deleteScheduleTerminationLoading = false;
			emManagementState.deleteScheduleTerminationSuccess = true;
		},
		deleteScheduleTerminationFailure: (state: TEmManagementStore) => {
			const emManagementState = state;
			emManagementState.deleteScheduleTerminationLoading = false;
			emManagementState.deleteScheduleTerminationSuccess = false;
		},

		assetsInitState: () => initialState,
	},
});

export default emManagement.reducer;
export const {
	getEmManagementListRequest,
	getEmManagementListSuccess,
	getEmByIdRequest,
	getEmByIdSuccess,
	getEmByIdFullRequest,
	getEmByIdFullSuccess,
	getEmByIdFullFailure,
	updateEmRequest,
	updateEmSuccess,
	updateEmFailure,
	updateEmerchantRequest,
	updateEmerchantSuccess,
	updateEmerchantFailure,
	unblockEmerchantRequest,
	unblockEmerchantSuccess,
	unblockEmerchantFailure,
	blockEmerchantRequest,
	blockEmerchantSuccess,
	blockEmerchantFailure,
	activateEmerchantRequest,
	activateEmerchantSuccess,
	activateEmerchantFailure,
	duplicateEmerchantRequest,
	duplicateEmerchantSuccess,
	duplicateEmerchantFailure,
	activateEuDdpRequest,
	activateEuDdpSuccess,
	activateEuDdpFailure,
	resetActivateEuDdp,
	getAdditionalServicesRequest,
	getAdditionalServicesSuccess,
	createAdditionalServiceRequest,
	createAdditionalServiceSuccess,
	createAdditionalServiceFailure,
	updateAdditionalServiceRequest,
	updateAdditionalServiceSuccess,
	updateAdditionalServiceFailure,
	getEmAdditionalServicesRequest,
	getEmAdditionalServicesSuccess,
	createEmAdditionalServiceRequest,
	createEmAdditionalServiceSuccess,
	createEmAdditionalServiceFailure,
	updateEmAdditionalServiceRequest,
	updateEmAdditionalServiceSuccess,
	updateEmAdditionalServiceFailure,
	emAdditionalServiceInvoiceRequest,
	emAdditionalServiceInvoiceSuccess,
	emAdditionalServiceInvoiceFailure,
	emInvoicePdfRequest,
	emInvoicePdfSuccess,
	emInvoicePdfFailure,
	// cancel em additional service
	emAdditionalServiceCancelRequest,
	emAdditionalServiceCancelSuccess,
	emAdditionalServiceCancelFailure,
	getSpecialRegistrationsRequest,
	getSpecialRegistrationsSuccess,
	addSpecialRegistrationRequest,
	addSpecialRegistrationSuccess,
	addSpecialRegistrationFailure,
	updateSpecialRegistrationRequest,
	updateSpecialRegistrationSuccess,
	updateSpecialRegistrationFailure,
	addScheduleTerminationRequest,
	addScheduleTerminationSuccess,
	addScheduleTerminationFailure,
	deleteScheduleTerminationRequest,
	deleteScheduleTerminationSuccess,
	deleteScheduleTerminationFailure,
	getEmEnumsRequest,
	getEmEnumsSuccess,
	getDistinctEnumNamesRequest,
	getDistinctEnumNamesSuccess,
	getDistinctEnumNamesFailure,
	getEnumByNameRequest,
	getEnumByNameSuccess,
	getEnumByNameFailure,
	getMonthlyFeesRequest,
	getMonthlyFeesSuccess,
	getFeeClassesRequest,
	getFeeClassesSuccess,
	// em comments
	getEmCommentsRequest,
	getEmCommentsSuccess,
	// em notifications
	getEmNotificationsRequest,
	getEmNotificationsSuccess,
	getEmCommentByIdRequest,
	getEmCommentByIdSuccess,
	createEmCommentRequest,
	createEmCommentSuccess,
	createEmCommentFailure,
	updateEmCommentRequest,
	updateEmCommentSuccess,
	updateEmCommentFailure,
	registerNominatedPersonAccountRequest,
	registerNominatedPersonAccountSuccess,
	registerNominatedPersonAccountFailure,
	// em sites
	getEmSitesListRequest,
	getEmSitesListSuccess,
	createEmSiteRequest,
	createEmSiteSuccess,
	updateEmSiteRequest,
	updateEmSiteSuccess,
	deleteEmSiteRequest,
	deleteEmSiteSuccess,
	// dashboard users subscriptions
	getEmDashboardUsersSubscriptionsRequest,
	getEmDashboardUsersSubscriptionsSuccess,
	updateEmDashboardUsersSubscriptionsRequest,
	updateEmDashboardUsersSubscriptionsSuccess,
	updateEmDashboardUsersSubscriptionsFailure,
	// em invoice list
	getEmInvoiceListRequest,
	getEmInvoiceListSuccess,
	// em payment methods
	getEmPaymentMethodsRequest,
	getEmPaymentMethodsSuccess,
	assetsInitState,
	resetBlockEmerchant,
} = emManagement.actions;
